import { DefaultButton, Dialog, DialogFooter, DialogType, Icon, IconButton, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, PrimaryButton, SpinButton, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, Toggle, TooltipHost, ValidationState } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../app/Hooks";
import { add, dismissMessage, getFromAccounts, getToAccounts, reset, resetFromAccountsSet, resetToAccountsSet, setIsFilteredToAccountSet, setMessage, setIsFilteredFromAccountSet, setSelectedFromAccountItems, setSelectedToAccountItems, setStage1, resetMessage, get, getTransactionSummary, setIsAuthorizationRequired, uploadFile, removeFile, deleteFile, } from "./TransferAmountFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, DynamicNumberInputField, InputField, NumberInputField } from "../../../controls/Controls";
import { inputs } from "../../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../../app/Api";
import { Message } from "../../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { currencyFormatter, formatBytes, formatDate, getIconNameFromMime, timestampToDate, toFixedWithoutRounding } from "../../../../../app/Helpers";
import { AuthenticateReply } from "../../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../../repository/Accountant/common_pb";
import { TableState } from "../../../../common/Table/TableSate";
import { GetAccountsRequest } from "../../../../../repository/Accountant/account_pb";
import { AccountStatus, AuthorizedOperation, Operations } from "../../../../../app/Enums";
import { GetCurrenciesRequest } from "../../../../../repository/Accountant/currency_pb";
import { GetTransactionSummary, GetTransactionSummaryRequest, TransferRequest, TransferResponse } from "../../../../../repository/Accountant/account_operation_pb";
import { List } from "../../../../common/List/List";
import { Popup } from "../../../../common/Popup/Popup";
import { AccountsPage } from "../../../../pages/Accountant/Accounts/AccountsPage";
import { GetBalanceReservationRequest, TransferAmountRequest } from "../../../../../repository/Accountant/balance_reservation_pb";
import { AuthorizationForm } from "../../Accounts/AuthorizationForm";
import { AddFileRequest, DeleteFileRequest } from "../../../../../repository/Accountant/file_pb";


let req: TransferAmountRequest;
let getFromAccountsReq: GetAccountsRequest;
let getToAccountsReq: GetAccountsRequest;

let promise: any;
let getFilterPromise: any;
let fileUploadAction: any
let uploadReq: AddFileRequest

let org: number = -1;
let current: AuthenticateReply.AsObject;
let currenciesReq: GetCurrenciesRequest;

export const TransferAmountForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showConfirmation, setShowConfirmation] = useState({
        type: DialogType.normal,
        title: '',
        subText: '',
    });
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();

    const modalPropsStyles = { main: { maxWidth: 450 } };

    const [currentAction, setCurrenctAction] = useState(0)

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(false);
    const modalProps = useMemo(
        () => ({
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: undefined,
        }),
        [isDraggable],
    );

    const state: { isLoading: boolean, attachments: any[], message: ApiMessage | undefined, stage1: any, from: TableState, to: TableState, confirmation: any[], requireAuth: boolean } = useAppSelector((state) => {

        return {
            isLoading: state.transferAmountForm.isLoading, message: state.transferAmountForm.message,
            stage1: state.transferAmountForm.stage1,
            from: state.transferAmountForm.from,
            to: state.transferAmountForm.to,
            confirmation: state.transferAmountForm.confirmation,
            requireAuth: state.transferAmountForm.requireAuth,
            attachments: state.transferAmountForm.attachments,


        }
    })

    const hiddenFileInputRef = useRef<any>(null);

    // 2) Function to trigger the click on the hidden input
    const handleShowFileDialog = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };
    useEffect(() => {
        var l = searchParams.get('org');
        req = new TransferAmountRequest();
        getFromAccountsReq = new GetAccountsRequest();
        getToAccountsReq = new GetAccountsRequest();
        uploadReq = new AddFileRequest();

        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                getFromAccountsReq.setOrganization(wrapper)
                getToAccountsReq.setOrganization(wrapper)
                uploadReq.setOrganization(wrapper);

            }
        }
        const boolv = new BoolValue();
        boolv.setValue(true);
        const stat = new Int32Value();
        stat.setValue(AccountStatus.ACTIVE);

        getFromAccountsReq.setNumofresults(state.from.numberOfResults)
        getFromAccountsReq.setOrder(state.from.isDescending)
        getFromAccountsReq.setStatus(stat)

        getToAccountsReq.setNumofresults(state.to.numberOfResults)
        getToAccountsReq.setOrder(state.to.isDescending)
        getToAccountsReq.setStatus(stat)

        if (props.renderObject && props.renderObject?.from) {

            dispatch(setSelectedFromAccountItems(([props.renderObject?.from])))

            const c = new StringValue();
            c.setValue(props.renderObject?.from?.currencyId)
            getToAccountsReq.setCurrency(c)
        }
        if (props.fetchData) {
            let r = new GetBalanceReservationRequest()
            r.setId(props?.renderObject?.id);
            promise?.abort()
            promise = dispatch(get({ body: r, headers: getHeaders() }))
        } else {
            dispatch(setStage1(props?.renderObject))
        }


        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            getFilterPromise?.abort();
            dispatch(reset());
        }
    }, [])


    useEffect(() => {
        if (state.confirmation.length > 0) {

            if (state.confirmation.at(0).debtorfeeValue != undefined && state.confirmation.at(0).debtorfeeValue != 0 && state.confirmation.at(0).creditorfeeValue != undefined && state.confirmation.at(0).creditorfeeValue != 0) {
                const formatteddebtFeeCurrency = currencyFormatter((state.confirmation.at(0).debtorfeeValue), { significantDigits: state.confirmation.at(0).currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                const formattedcreditFeeCurrency = currencyFormatter((state.confirmation.at(0).creditorfeeValue), { significantDigits: state.confirmation.at(0).currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                const formattedCurrency = currencyFormatter((state.confirmation.at(0).amount), { significantDigits: state.confirmation.at(0)?.currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })

                setShowConfirmation({
                    type: DialogType.normal,
                    title: t("confirm"),
                    subText: t("transferConfirmWithFee", { creditorFeeAmount: formattedcreditFeeCurrency, debtorFeeAmount: formatteddebtFeeCurrency, amount: formattedCurrency, from: state.from.selected.at(0).name ?? "", to: state.to.selected.at(0).name }),
                })

            } else if (state.confirmation.at(0).debtorfeeValue != undefined && state.confirmation.at(0).debtorfeeValue != 0) {
                const formatteddebtFeeCurrency = currencyFormatter((state.confirmation.at(0).debtorfeeValue), { significantDigits: state.confirmation.at(0).currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                const formattedCurrency = currencyFormatter((state.confirmation.at(0).amount), { significantDigits: state.confirmation.at(0)?.currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                setShowConfirmation({
                    type: DialogType.normal,
                    title: t("confirm"),
                    subText: t("transferConfirmWithDebitFee", { debtorFeeAmount: formatteddebtFeeCurrency, amount: formattedCurrency, from: state.from.selected.at(0).name ?? "", to: state.to.selected.at(0).name }),
                })
            } else if (state.confirmation.at(0).creditorfeeValue != undefined && state.confirmation.at(0).creditorfeeValue != 0) {
                const formattedcreditFeeCurrency = currencyFormatter((state.confirmation.at(0).creditorfeeValue), { significantDigits: state.confirmation.at(0).currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                const formattedCurrency = currencyFormatter((state.confirmation.at(0).amount), { significantDigits: state.confirmation.at(0)?.currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                setShowConfirmation({
                    type: DialogType.normal,
                    title: t("confirm"),
                    subText: t("transferConfirmWithCreditFee", { creditorFeeAmount: formattedcreditFeeCurrency, amount: formattedCurrency, from: state.from.selected.at(0).name ?? "", to: state.to.selected.at(0).name }),
                })
            } else {
                const formattedCurrency = currencyFormatter((state.confirmation.at(0).amount), { significantDigits: state.confirmation.at(0)?.currencyDecimalPlaces ?? 9, symbol: state.confirmation.at(0)?.currencySymbol })
                setShowConfirmation({
                    type: DialogType.normal,
                    title: t("confirm"),
                    subText: t("transferConfirm", { amount: formattedCurrency, from: state.from.selected.at(0).name ?? "", to: state.to.selected.at(0).name }),
                })
            }
            toggleHideDialog()
        }
    }, [state.confirmation])

    const toSuggestionsProps: ISuggestionsProps<IPersonaProps> = {
        suggestionsHeaderText: t('accounts'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.to.hasMore && !state.to.isFetching,
        onRenderSuggestion: (props: IPersonaProps) => {


            return <Persona {...props} size={PersonaSize.size32} showSecondaryText={true} styles={{ root: { margin: 8 } }} />;
        },

        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.to.items.findIndex(e => e.internalId == item.key)
            if (u >= 0) {
                dispatch(setSelectedToAccountItems([state.to.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.to.items.length > 0 && !state.to.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.to.items.at(state.to.items.length - 1).internalId);
                getToAccountsReq.setNextto(wrapper)
                getFilterPromise = dispatch(getToAccounts({ body: getToAccountsReq, headers: getHeaders() }))
            }
        },
        suggestions: state.to.items.length > 0 ? state.to.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : [],
        isLoading: state.to.items.length == 0 ? state.to.isFetching : false,
        isSearching: state.to.items.length > 0 ? state.to.isFetching : false,


    };


    const onToAccountsFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {

        dispatch(resetToAccountsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        getToAccountsReq.setSearch(wrapper)
        getToAccountsReq.setNextto(undefined)
        if (state.from.selected.length > 0) {
            let r = new StringValue();
            r.setValue(state.from.selected.at(0).currencyId);
            getToAccountsReq.setCurrency(r);
        }
        dispatch(setIsFilteredToAccountSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getToAccounts({ body: getToAccountsReq, headers: getHeaders() }))
        return [];


    }




    const fromSuggestionsProps: ISuggestionsProps<IPersonaProps> = {
        suggestionsHeaderText: t('accounts'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.from.hasMore && !state.from.isFetching,
        onRenderSuggestion: (props: IPersonaProps) => {


            return <Persona {...props} size={PersonaSize.size32} showSecondaryText={true} styles={{ root: { margin: 8 } }} />;
        },

        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.from.items.findIndex(e => e.internalId == item.key)
            if (u >= 0) {
                dispatch(setSelectedFromAccountItems([state.from.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.from.items.length > 0 && !state.from.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.from.items.at(state.from.items.length - 1).internalId);
                getFromAccountsReq.setNextto(wrapper)
                getFilterPromise = dispatch(getFromAccounts({ body: getFromAccountsReq, headers: getHeaders() }))
            }
        },
        suggestions: state.from.items.length > 0 ? state.from.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : [],
        isLoading: state.from.items.length == 0 ? state.from.isFetching : false,
        isSearching: state.from.items.length > 0 ? state.from.isFetching : false,


    };


    const onFromAccountsFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {

        dispatch(resetFromAccountsSet())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        getFromAccountsReq.setSearch(wrapper)
        getFromAccountsReq.setNextto(undefined)
        if (state.to.selected.length > 0) {
            let r = new StringValue();
            r.setValue(state.to.selected.at(0).currencyId);
            getFromAccountsReq.setCurrency(r);
        }
        dispatch(setIsFilteredFromAccountSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getFromAccounts({ body: getFromAccountsReq, headers: getHeaders() }))
        return [];


    }





    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("accounts")} onDismiss={() => { setCurrenctAction(0) }} >

                <AccountsPage isSelection={true} onItemSelected={(e) => {
                    if (state.to.selected.length > 0) {
                        if (state.to.selected.at(0).currencyId != e.currencyId) {
                            setCurrenctAction(0)
                            return;
                        }
                    }
                    dispatch(setSelectedFromAccountItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            <Popup isOpen={(currentAction == 101)} title={t("accounts")} onDismiss={() => { setCurrenctAction(0) }} >

                <AccountsPage isSelection={true} onItemSelected={(e) => {
                    if (state.from.selected.length > 0) {
                        if (state.from.selected.at(0).currencyId != e.currencyId) {
                            setCurrenctAction(0)
                            return;
                        }
                    }
                    dispatch(setSelectedToAccountItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>


            <Formik
                enableReinitialize={true}
                initialValues={{

                    from: undefined,
                    to: undefined,
                    amount: (state.stage1?.amount) ? state.stage1?.amount : "",
                    extraFields: (state.stage1?.extraFields) ? state.stage1?.extraFields as DynamicField[] : [] as DynamicField[],
                    message: "",
                    advancedOptions: false,
                    description: ""


                }}

                validationSchema={Yup.object({
                    amount: inputs.amount,
                    extraFields: inputs.extraFields,
                    message: inputs.message,
                    description: inputs.message,


                })}

                onSubmit={(values, actions) => {
                    if (props.type == FormType.ADD) {

                        let from = state.from.selected.at(0);
                        let to = state.to.selected.at(0);
                        if (from.internalId == to.internalId) {
                            dispatch(setSelectedToAccountItems([]))
                            return;
                        }
                        let amount = "";
                        let formattedCurrency = "";
                        if (values.amount) {
                            let r = (toFixedWithoutRounding((values.amount?.replace(/,/g, '')), to?.currencyDecimalPlaces ?? 9))
                            if (Number(r) <= 0) {
                                actions.setFieldValue("amount", "")
                                return;
                            }
                            formattedCurrency = currencyFormatter(r, { significantDigits: to?.currencyDecimalPlaces ?? 9, symbol: to?.currencySymbol })
                            amount = r + ""
                        }

                        req.setId(props.renderObject?.id)
                        req.setCreditor(to.internalId)

                        const wrapperdesc = new StringValue();
                        wrapperdesc.setValue(values?.description);
                        req.setDescription(wrapperdesc)


                        if (values.advancedOptions) {
                            const wrapper = new StringValue();
                            wrapper.setValue(values.advancedOptions ? values.message : "");
                            req.setMessage(wrapper)

                            const extraField: ExtraField[] = [];
                            const count: Number = 1;
                            state.attachments.forEach((e: any) => {
                                const r = new ExtraField();
                                r.setKey(e.fileId);
                                extraField.push(r)
                            })
                            req.setAttachmentsList(extraField)

                        }


                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        req.setExtrafieldsList(extraField)
                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: TransferResponse.AsObject) => {

                                // dispatch(setMessage()
                                //dispatch(setSelectedToAccountItems([]))
                                actions.resetForm();
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res?.success?.transactionid,
                                            internalId: res?.success?.transactioninternalid,
                                            amount: amount,
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,
                                            extraFields: values.extraFields,
                                            message: { body: t("transferSuccessDesc", { amount: formattedCurrency, account: to?.name ?? "", accountId: to?.internalId ?? "" }), type: 1, title: t("transferSuccessTitle", { transaction: res?.success?.transactionid ?? "", transactionId: res?.success?.transactioninternalid ?? "" }), data: undefined }

                                        });
                                    }
                                }
                                actions.setSubmitting(false)
                            })
                            .catch((error: ApiMessage) => {

                                actions.setSubmitting(false)
                            })
                    } else {

                    }
                }}

            >
                {formkikProps => (
                    <Form onSubmit={(e) => {
                        e.preventDefault()

                        let a = Number(formkikProps.values.amount?.replace(/,/g, ''))
                        if (isNaN(a) || !formkikProps.isValid || a == 0) {
                            return;
                        }
                        dispatch(resetMessage())
                        if (state.from.selected.at(0).internalId == state.to.selected.at(0).internalId) {
                            dispatch(setSelectedToAccountItems([]))
                            return;
                        }
                        const formattedCurrency = currencyFormatter((formkikProps.values.amount?.replace(/,/g, '')), { significantDigits: state.to.selected.at(0)?.currencyDecimalPlaces ?? 9, symbol: state.to.selected.at(0)?.currencySymbol })

                        let from = state.from.selected.at(0);
                        let to = state.to.selected.at(0);
                        req.setAuthcode(undefined)
                        if (from.isAuthorizationRequired || state.requireAuth) {
                            setCurrenctAction(13);
                            return;
                        }

                        var sumary = new GetTransactionSummaryRequest();
                        const set: GetTransactionSummary[] = [];
                        const trans = new GetTransactionSummary();
                        trans.setAmount(formkikProps.values.amount?.replace(/,/g, ''))
                        trans.setCreditor(to.internalId)
                        trans.setDebtor(from.internalId)
                        trans.setOperation(Operations.TRANSFER)
                        set.push(trans)
                        sumary.setTransactionsList(set)
                        promise?.abort();
                        promise = dispatch(getTransactionSummary({ body: sumary, headers: getHeaders() }))

                    }} >
                        <Popup isOpen={(currentAction == 13)} title={t("authorization")} onDismiss={() => { setCurrenctAction(0) }} >
                            <AuthorizationForm childrenGap={10} maxWidth={280} type={FormType.EDIT} renderObject={{
                                account: state.from.selected.at(0),
                                operation: AuthorizedOperation.TRANSFER,
                                parameters: [{ key: "Amount", value: formkikProps.values.amount?.replace(/,/g, ''), viewValue: state.from.selected.at(0)?.currencySymbol }, { key: "To", value: state.to.selected.at(0)?.id + "", viewValue: state.to.selected.at(0)?.id + "" }],
                            }} onSuccess={(e) => {
                                if (req && e.authCode) {
                                    if (currentAction == 13) {
                                        var r = new StringValue();
                                        r.setValue(e.authCode)
                                        req.setAuthcode(r)
                                        setCurrenctAction(0)


                                        let from = state.from.selected.at(0);
                                        let to = state.to.selected.at(0);

                                        var sumary = new GetTransactionSummaryRequest();
                                        const set: GetTransactionSummary[] = [];
                                        const trans = new GetTransactionSummary();
                                        trans.setAmount(formkikProps.values.amount?.replace(/,/g, ''))
                                        trans.setCreditor(to.internalId)
                                        trans.setDebtor(from.internalId)
                                        trans.setOperation(Operations.TRANSFER)
                                        set.push(trans)
                                        sumary.setTransactionsList(set)
                                        promise?.abort();
                                        promise = dispatch(getTransactionSummary({ body: sumary, headers: getHeaders() }))

                                    }
                                } else {
                                    setCurrenctAction(0)
                                }
                            }} onCancel={() => { setCurrenctAction(0) }} />
                        </Popup>
                        <Dialog
                            hidden={hideDialog}
                            onDismiss={toggleHideDialog}
                            dialogContentProps={showConfirmation}
                            modalProps={modalProps}
                        >
                            <DialogFooter>
                                <PrimaryButton autoFocus onClick={(e: any) => { formkikProps.handleSubmit(e); toggleHideDialog() }} text={t("transfer")} type="submit" />
                                <DefaultButton onClick={toggleHideDialog} text={t("cancel")} />
                            </DialogFooter>
                        </Dialog>
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }

                            {props.type == FormType.ADD ? <Stack grow>
                                <Label required disabled={state.isLoading}>{t("from")}</Label>
                                <List
                                    isPeoplePicker={true}
                                    suggestionsHeaderText={t('accounts')}
                                    isLoading={state.from.items.length == 0 ? state.from.isFetching : false}
                                    isSearching={state.from.items.length > 0 ? state.from.isFetching : false}
                                    moreSuggestionsAvailable={state.from.hasMore && !state.from.isFetching}
                                    suggestions={state.from.items.length > 0 ? state.from.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.from.items.length > 0 && !state.from.isFetching) {
                                            const wrapper = new StringValue();
                                            wrapper.setValue(state.from.items.at(state.from.items.length - 1).internalId);
                                            getFromAccountsReq.setNextto(wrapper)
                                            getFilterPromise = dispatch(getFromAccounts({ body: getFromAccountsReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.from.items.findIndex(e => e.internalId == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedFromAccountItems([state.from.items.at(u)]))
                                        }
                                    }}
                                    inputProps={{ placeholder: t("from"), required: true }}

                                    disabled={state.isLoading || props.renderObject?.from ? true : false}
                                    selectedItems={state.from.selected.length > 0 ? state.from.selected.map(e => { return { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } as IPersonaProps }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedFromAccountItems([]))
                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetFromAccountsSet())
                                        getFromAccountsReq.setSearch(undefined)
                                        getFromAccountsReq.setNextto(undefined)
                                        if (state.to.selected.length > 0) {
                                            let r = new StringValue();
                                            r.setValue(state.to.selected.at(0).currencyId);
                                            getFromAccountsReq.setCurrency(r);
                                        }
                                        dispatch(setIsFilteredFromAccountSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getFromAccounts({ body: getFromAccountsReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onFromAccountsFilterChanged}
                                    endButtons={state.from.selected?.at(0)?.isAuthorizationRequired ? [
                                        {
                                            title: t("more"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(100);
                                            }
                                        }
                                    ] : [
                                        {
                                            title: t("more"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(100);
                                            }
                                        },
                                        {
                                            title: state.requireAuth ? t("operationAuthorizationEnabled") : t("operationAuthorizationDisabled"), checked: state.requireAuth, disabled: false, iconProps: { iconName: !state.requireAuth ? "Unlock" : "Lock" },
                                            onClick: () => {
                                                dispatch(setIsAuthorizationRequired(!state.requireAuth))
                                            }
                                        }
                                    ]}
                                />

                            </Stack> : undefined}

                            {props.type == FormType.ADD ? <Stack grow>
                                <Label required disabled={state.isLoading}>{t("to")}</Label>
                                <List
                                    isPeoplePicker={true}
                                    suggestionsHeaderText={t('accounts')}
                                    isLoading={state.to.items.length == 0 ? state.to.isFetching : false}
                                    isSearching={state.to.items.length > 0 ? state.to.isFetching : false}
                                    moreSuggestionsAvailable={state.to.hasMore && !state.to.isFetching}
                                    suggestions={state.to.items.length > 0 ? state.to.items.map(e => { return { item: { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } } as ISuggestionModel<IPersonaProps> }) : []}
                                    onGetMoreResults={() => {
                                        if (state.to.items.length > 0 && !state.to.isFetching) {
                                            const wrapper = new StringValue();
                                            wrapper.setValue(state.to.items.at(state.to.items.length - 1).internalId);
                                            getToAccountsReq.setNextto(wrapper)
                                            getFilterPromise = dispatch(getToAccounts({ body: getToAccountsReq, headers: getHeaders() }))
                                        }
                                    }}
                                    onSuggestionClick={(ev?, item?: any, index?: number) => {
                                        var u = state.to.items.findIndex(e => e.internalId == item.key)
                                        if (u >= 0) {
                                            dispatch(setSelectedToAccountItems([state.to.items.at(u)]))
                                        }
                                    }}
                                    inputProps={{ placeholder: t("to"), required: true }}

                                    disabled={state.isLoading}
                                    selectedItems={state.to.selected.length > 0 ? state.to.selected.map(e => { return { key: e.internalId, text: e.name + " (#" + e.id + ")", secondaryText: e.ownerName + " | " + e.accountTypeName, imageInitials: e.currencySymbol ?? e.currencyCode } as IPersonaProps }) : []}
                                    onChange={(e) => {
                                        dispatch(setSelectedToAccountItems([]))
                                    }}
                                    onEmptyInputFocus={() => {
                                        dispatch(resetToAccountsSet())
                                        getToAccountsReq.setSearch(undefined)
                                        getToAccountsReq.setNextto(undefined)
                                        if (state.from.selected.length > 0) {
                                            let r = new StringValue();
                                            r.setValue(state.from.selected.at(0).currencyId);
                                            getToAccountsReq.setCurrency(r);
                                        }
                                        dispatch(setIsFilteredToAccountSet(false))
                                        getFilterPromise?.abort()
                                        getFilterPromise = dispatch(getToAccounts({ body: getToAccountsReq, headers: getHeaders() }))
                                        return []
                                    }}
                                    onFilterChanged={onToAccountsFilterChanged}
                                    endButtons={[
                                        {
                                            title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                            onClick: () => {
                                                setCurrenctAction(101)

                                            }
                                        }]}
                                />

                            </Stack> : undefined}
                            {props.type == FormType.ADD ?
                                <Field name="amount" label={t("amount")} placeholder={t("amount")}
                                    component={InputField} disabled={true} maxLength={15}
                                    onBlur={(event: any) => {
                                        if (isNaN(Number(formkikProps.values.amount?.replace(/,/g, '')))) {
                                            formkikProps.handleBlur(event);
                                            return;
                                        }
                                        let from = state.from.selected.at(0);
                                        let to = state.to.selected.at(0);
                                        if (from)
                                            formkikProps.setFieldValue("amount", toFixedWithoutRounding((formkikProps.values.amount?.replace(/,/g, '')), from?.currencyDecimalPlaces ?? 9))
                                        else if (to)
                                            formkikProps.setFieldValue("amount", toFixedWithoutRounding((formkikProps.values.amount?.replace(/,/g, '')), to?.currencyDecimalPlaces ?? 9))
                                        else
                                            formkikProps.setFieldValue("amount", toFixedWithoutRounding((formkikProps.values.amount?.replace(/,/g, '')), 9))
                                        formkikProps.handleBlur(event);
                                    }}
                                    required suffix={state.from?.selected?.at(0)?.currencyCode ?? state.to?.selected?.at(0)?.currencyCode} />


                                : undefined}

                            <Field name="description" label={
                                <div>
                                    {t("description") + ' '}
                                    <TooltipHost content={t("descriptionDesc")}>
                                        <Icon iconName="Info" aria-label={t("description")} />
                                    </TooltipHost>
                                </div>
                            } placeholder={t("description")} component={InputField} rows={3} multiline resizable={false} disabled={state.isLoading} maxLength={140} />


                            <Toggle

                                label={t("advancedOptions")}
                                disabled={state.isLoading}

                                checked={formkikProps.values.advancedOptions}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('advancedOptions', checked);
                                }
                                }
                            />

                            {formkikProps.values.advancedOptions ?
                                <Field name="message" label={
                                    <div>
                                        {t("message") + ' '}
                                        <TooltipHost content={t("messageDesc")}>
                                            <Icon iconName="Info" aria-label={t("message")} />
                                        </TooltipHost>
                                    </div>
                                } placeholder={t("message")} component={InputField} rows={3} multiline resizable={false} disabled={state.isLoading} maxLength={140} />
                                : undefined}

                            {formkikProps.values.advancedOptions ? <Stack.Item>
                                <Label disabled={state.isLoading}>{
                                    <div>
                                        {t("attachments") + ' '}
                                        <TooltipHost content={t("attachmentHint")}>
                                            <Icon iconName="Info" aria-label={t("attachments")} />
                                        </TooltipHost>
                                    </div>
                                }</Label>
                                <FieldArray
                                    name="attachments"
                                    validateOnChange={false}

                                >
                                    {arrayHelpers => {
                                        let r = [] as React.ReactNode[];
                                        if (state.attachments && state.attachments.length > 0) {

                                            r.push(state.attachments.map((row, rowIndex) => {

                                                return (<Stack
                                                    horizontal
                                                    verticalAlign="center"
                                                    styles={{ root: { padding: 8, border: '1px solid #ccc', borderRadius: 4, maxWidth: 300 } }}
                                                    tokens={{ childrenGap: 8 }}
                                                >

                                                    <Icon iconName={getIconNameFromMime(row.mime)} styles={{ root: { fontSize: 24 } }} />

                                                    <Stack.Item grow>
                                                        <Stack>
                                                            <Text variant="mediumPlus" styles={{
                                                                root: {
                                                                    fontWeight: 600,
                                                                    // Truncation properties
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    maxWidth: 150,
                                                                    display: 'inline-block',
                                                                }
                                                            }}>
                                                                {row.originalName}
                                                            </Text>
                                                            <Text variant="small">{row.size}</Text>
                                                        </Stack>
                                                    </Stack.Item>

                                                    {row.isLoading ? <Spinner size={SpinnerSize.large} /> : <IconButton
                                                        iconProps={{ iconName: 'Cancel' }}
                                                        title={t("cancel")}
                                                        disabled={state.isLoading}
                                                
                                                        ariaLabel={t("cancel")}
                                                        onClick={() => {
                                                            if (row.isLoading) {
                                                                if (fileUploadAction)
                                                                    fileUploadAction.abort();
                                                                dispatch(removeFile(row.id))
                                                            } else {
                                                                let r = new DeleteFileRequest();
                                                                r.setId(row.fileId)
                                                                dispatch(deleteFile({ body: r, headers: getHeaders(), metadata: { id: row.id } }))
                                                            }
                                                        }}
                                                        styles={{ root: { marginLeft: 4 } }}
                                                    />}
                                                </Stack>

                                                )
                                            })
                                            )

                                        }
                                        if (state.attachments.length < 3) {
                                            const ALLOWED_EXTENSIONS = [
                                                '.jpg',
                                                '.jpeg',
                                                '.png',
                                                '.pdf',
                                                '.txt',
                                                '.doc',
                                                '.docx',
                                                '.xls',
                                                '.xlsx',
                                                '.heif',
                                                '.heic',
                                            ];

                                            r.push(<IconButton disabled={state.isLoading}
                                                key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {

                                                    handleShowFileDialog();

                                                }} >

                                                <input
                                                    type="file"
                                                    ref={hiddenFileInputRef}
                                                    style={{ display: "none" }}
                                                    accept={ALLOWED_EXTENSIONS.join(',')}
                                                    onChange={(e: any) => {
                                                        if (e.target.files && e.target.files.length > 0) {
                                                            // For example, push a new item with these files

                                                            //arrayHelpers.push({ key: (formkikProps.values.attachments.length + 1) + "", label: undefined, type: 1, value: event.target.files, autoFocus: false })

                                                            const [file] = e.target.files;
                                                            const reader = new FileReader();
                                                            reader.readAsArrayBuffer(file);
                                                            if (file.size > 8000000) {
                                                                //alert("File size must not exceed 5 MB.");
                                                                // Optional: reset the input if you want to clear it
                                                                //e.target.value = null; 
                                                                formkikProps.setFieldError("attachments", t("fileSizeLimit"))
                                                                return;
                                                            }
                                                            reader.onloadend = (evt) => {
                                                                if (evt?.target?.readyState === FileReader.DONE) {
                                                                    const arrayBuffer = evt.target.result;
                                                                    let array = new Uint8Array(arrayBuffer as ArrayBuffer);
                                                                    uploadReq.setFile(array)
                                                                    const fullName = file.name?.split(".")[0] ?? "file";

                                                                    uploadReq.setName(fullName)
                                                                    const mimeType = file.type || ""; // If the type isn't recognized, it may be ""
                                                                    uploadReq.setMime(mimeType)

                                                                    fileUploadAction = dispatch(uploadFile({ body: uploadReq, headers: getHeaders(), metadata: { mime: mimeType, size: formatBytes(file.size ?? 0), originalName: uploadReq.getName(), id: (new Date()).getTime() } }))


                                                                }
                                                            }

                                                        }
                                                        e.target.value = ''
                                                        //handleFilesChange(event.target.files, arrayHelpers)

                                                    }

                                                    }
                                                // If you do NOT want multiple, remove the `multiple` attribute above
                                                />

                                            </IconButton>)
                                        }
                                        return r;
                                    }
                                    }

                                </FieldArray>
                            </Stack.Item>
                                : undefined}

                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("extraFields") + ' '}
                                    <TooltipHost content={t("extraInformationDescription")}>
                                        <Icon iconName="Info" aria-label={t("extraFields")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="extraFields"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.extraFields && formkikProps.values.extraFields.length > 0) {
                                        r = formkikProps.values.extraFields.map((o, index) => {
                                            if (o.type == 1) {
                                                return (<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }} key={index}>
                                                    {o.label != undefined ? <Stack.Item grow> <DynamicInputField name={`extraFields[${index}].label`} placeholder={t("extraFieldLabel")} disabled={state.isLoading}
                                                        maxLength={50} autoFocus={(o as any)?.autoFocus} /> </Stack.Item> : null}
                                                    <Stack.Item grow>  <DynamicInputField name={`extraFields[${index}].value`} placeholder={t("extraFieldValue")} disabled={state.isLoading}
                                                        maxLength={50}
                                                    /></Stack.Item>

                                                    <IconButton disabled={state.isLoading}
                                                        iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                </Stack>)
                                            }
                                        }
                                        )
                                    }
                                    if (formkikProps.values.extraFields.length <= 4) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.extraFields.length + 1) + "", label: "", type: 1, value: "", autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>

                        </Stack>
                        <DialogFooter>
                            <PrimaryButton type="submit" disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("transfer") : t("edit")}
                            >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>

                    </Form>
                )}
            </Formik>
        </>
    );

}

